import React from "react";
import styled from "styled-components";
import { CUSTOM_COLORS } from "../theme/colorUtils";

const FooterContainer = styled.div`
	text-align: center;
	margin-top: 1.5rem;
	color: #999;
	font-size: 0.75rem;

	a {
		color: #999;
		text-decoration: none;

		&:hover {
			color: ${CUSTOM_COLORS.PRIMARY};
		}
	}
`;

interface FooterProps {
	className?: string;
	style?: React.CSSProperties;
}

const Footer: React.FC<FooterProps> = ({ className, style }) => {
	return (
		<FooterContainer className={className} style={style}>
			<a href="/privacy-policy">Privacy Policy</a> | © 2026 Creatorverse
		</FooterContainer>
	);
};

export default Footer;
